import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import './TestForm.scss'
import Barcode from './Barcode'

const DEFAULT_IMAGE_URL = 'https://oceanconservancy.org/wp-content/themes/oco-wp/images/header-video.jpg'

class TestView extends React.Component {
  static defaultProps = {
    setValue: _.noop,
    clearTestData: _.noop,
    submitTestData: _.noop,
    loading: false,
    testGroups: [],
    gridImageUrl: DEFAULT_IMAGE_URL,
    barcodeValue: null
  }

  static propTypes = {
    gridImageUrl: PropTypes.string,
    loading: PropTypes.bool,
    testGroups: PropTypes.arrayOf(PropTypes.shape({})),
    clearTestData: PropTypes.func,
    submitTestData: PropTypes.func,
    setValue: PropTypes.func,
    barcodeValue: PropTypes.string
  }

  renderTable = (tableRows) => {
    return (
      <table className='table'>
        <thead className='thead-light'>
          <tr>
            <th scope='col'>Test Step</th>
            <th scope='col'>Start Test</th>
            <th scope='col'>Checks</th>
            <th scope='col'>Passed?</th>
            <th scope='col'>Notes</th>
          </tr>
        </thead>
        <tbody>
          {tableRows}
        </tbody>
      </table>
    )
  }

  renderInput = (input) => {
    const { setValue } = this.props
    if (input.type === 'checkbox') {
      return (
        <div
          key={input.key}
          className={`form-check text-left ${input.readOnly ? 'disabled' : ''}`}
        >
          <label className='form-check-label'>
            <input
              type='checkbox'
              className='form-check-input'
              checked={input.value}
              onChange={(event) => setValue(input.key, event.target.checked)}
              disabled={Boolean(input.readOnly)}
            />
            {input.prompt}
          </label>
        </div>
      )
    } else {
      return (
        <div key={input.key}>
          <input
            type={input.type}
            className='form-control input-box'
            onChange={(event) => setValue(input.key, event.target.value)}
            placeholder={input.placeholder}
            value={input.value}
            required
          />
        </div>
      )
    }
  }

  submitTestData = (e) => {
    const { submitTestData } = this.props
    if (this.form) {
      if (this.form.checkValidity() === false) {
        e.preventDefault()
        e.stopPropagation()
        this.form.classList.add('was-validated')
      } else {
        submitTestData(e)
      }
    }
  }

  render () {
    const { gridImageUrl, loading, testGroups, clearTestData, barcodeValue } = this.props

    let tableRows = []
    _.forEach(testGroups, (group) => {
      tableRows.push((
        <tr>
          <th scope='row' colSpan='4' className='table-primary'>
            <h6 className='text-left'>{group.title}</h6>
          </th>
        </tr>
      ))
      if (group.key === 'grid_image') {
        tableRows.push((
          <tr>
            <td colSpan='4'>
              <img src={gridImageUrl} style={{ maxWidth: '100%' }} />
            </td>
          </tr>
        ))
        tableRows.push((
          <tr>
            <td colSpan='4'>
              Z Planes: [{group.z_planes ? group.z_planes.join(', ') : null }]
            </td>
          </tr>
        ))
      }
      _.forEach(group.tests, (test) => {
        const passed = _.every(test.inputs, (input) => input.value)
        const inputElements = _.map(test.inputs, this.renderInput)

        tableRows.push((
          <tr scope='row' key={test.key}>
            <td className='text-left'> {test.step} </td>
            <td>
              {
                test.manualStart
                  ?
                  <button
                    className='btn btn-secondary'
                    onClick={test.startTest}
                  >
                    Start
                  </button>
                  :
                  'N/A'
                }
            </td>
            <td>
              <div>
                {inputElements}
              </div>
            </td>
            <td className={(passed && !loading) ? 'table-success' : 'table-danger'}>
              {
                loading && !test.manualStart
                  ?
                  <div className='loading-container'>
                    <div className='loading' />
                  </div>
                  :
                  passed ? 'Passed' : 'Not Passed'
              }
            </td>
          </tr>
        ))
      })
    })

    return (
      <div>
        <a id="downloadLink" download="result.jpg"></a>
        <form
          ref={form => this.form = form}
          noValidate
        >
          <table className='table table-bordered'>
            <thead className='thead-light'>
              <tr>
                <th scope='col' className='text-left'>Test Step</th>
                <th scope='col'>Start Test</th>
                <th scope='col'>Checks</th>
                <th scope='col'>Passed?</th>
              </tr>
            </thead>
            <tbody>
              {tableRows}
            </tbody>
          </table>
          <div className='form-group'>
            <div className='text-left'>Date: {new Date().toDateString()}</div>
          </div>
          {
            barcodeValue ? (
              <Barcode
                value={barcodeValue}
              />
            ) : null
          }
          <div className='text-right' style={{ marginBottom: 20 }}>
            <button type='submit' className='btn btn-secondary clear-button' onClick={clearTestData}>Clear</button>
            <a href={gridImageUrl} download='new_image_name' className='btn btn-outline-primary download-button'>Download Image</a>
            <button type='submit' className='btn btn-primary' onClick={this.submitTestData}>Submit and Generate PDF</button>
          </div>
        </form>
      </div>
    )
  }
}

export default TestView



// WEBPACK FOOTER //
// ./src/components/TestForm.js